export default __webpack_public_path__ + "static/sea_rainbow-ca96ae8cfe0988de55c906cea32751f7.png";